<template>
<div>

  <el-descriptions title="" :column="1" border label-style="width: 120px;">
    <el-descriptions-item label="抄表-放水前">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="抄表-防水前" >
      </FitmentFileSubgroup>
    </el-descriptions-item>
    <el-descriptions-item label="抄表-补水后">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="抄表-补水后" >
      </FitmentFileSubgroup>
    </el-descriptions-item>
    <el-descriptions-item label="消防材料合格证">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="消防材料合格证" >
      </FitmentFileSubgroup>
    </el-descriptions-item>
    <el-descriptions-item label="消防检验报告">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="消防检验报告" >
      </FitmentFileSubgroup>
    </el-descriptions-item>
  </el-descriptions>
  <div class="form-page-title-info"><el-button  type="primary" @click="pushShow('temporary')">添加消防收费</el-button></div>
  <el-table height="30vh" v-loading="loading" v-if="pageData" :data="pageData.list" border style="width: 100%">
    <el-table-column prop="id" label="ID" width="80"></el-table-column>
    <el-table-column prop="h_name" label="业户" width="100"></el-table-column>
    <el-table-column prop="address" label="房产"></el-table-column>
    <el-table-column prop="charge_name" label="临时费用名称"></el-table-column>
    <el-table-column prop="charge" label="金额" width="100"></el-table-column>
    <el-table-column prop="payment_number" label="缴款方式" width="100"></el-table-column>
    <el-table-column prop="bill_number" label="票据号" width="110"></el-table-column>
    <el-table-column prop="user" label="操作人" width="80"></el-table-column>
    <el-table-column prop="remarks" label="备注"></el-table-column>
    <el-table-column prop="date" label="操作时间" width="140"></el-table-column>
  </el-table>
  <div class="pagination-wrap">
    <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                   :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                   @current-change="pageChange"></el-pagination>
  </div>
</div>
</template>

<script>
import FitmentFileSubgroup from "../FitmentFileSubgroup";
import AppConfig from "../../../../../../../../config/AppConfig";
export default {
  name: "PreparationForEntry",
  components: {FitmentFileSubgroup},
  inject:['mainObj','componentId','setComponentId','ProcessState','setProcessState'],
  data(){
    return{
      loading:false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 12,
        page: 1,
      },
    }
  },
  mounted() {
    this.getList();
  },
  methods:{
    getFile(file_name) {
      let url=AppConfig.erp_server+"/admin/HouseFurnish/download?file_name="+file_name;
      window.open(url, "_blank");
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    getList() {
      const that = this;
      that.loading = true;
      ERP.postRequest({
        url: "admin/HouseFurnish/temporaryList",
        data: {
          page: that.pageData.page,
          pageSize: that.pageData.pageSize,
          fitment_id: that.mainObj.id,
          text: "消防放水"
        }
      }, res => {
        if(res.code == 200) {
          that.pageData.list = res.data
          that.pageData.total = res.count
          that.pageData.pageSize = res.pageSize
        }
          that.loading = false;
      })
    },
    pushShow(url) {
      window.open('/#/order/'+url, '_blank');
    },
  }
}
</script>

<style scoped>
.form-page-title-info{
	  width:100%;
	  padding: 4px 0px;
	  font-weight: 700;
	  line-height: 36px;
	  background-color: #f7f8fa;
	  border-bottom: 1px solid #e5e5e5;
    margin-top: 5px;
	}
  .pagination-wrap{
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/furnish/components/pda_check/FireManagement.vue